import React, { useEffect, useState } from "react";
import CardBox from "../common/CardBox";
import { Link } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  DatePicker,
  Flex,
  Form,
  GetProp,
  Input,
  Select,
  Space,
  Table,
  TableProps,
  Tag,
  Typography,
} from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  PlusOutlined,
  HomeOutlined,
  HomeTwoTone,
  ShopOutlined,
  CoffeeOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { ColumnsType, SorterResult } from "antd/es/table/interface";
import qs from "qs";
import CommonDataTable from "../common/CommonDataTable";
import { useNavigate } from "react-router-dom";

interface DataType {
  name: {
    first: string;
    last: string;
  };
  gender: string;
  email: string;
  login: {
    uuid: string;
  };
}

interface TableParams {
  pagination?: any;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const { Title, Text } = Typography;
const columns: ColumnsType<DataType> = [
  {
    title: "Booking Number",
    dataIndex: "booking_number",
    sorter: true,
    render: (booking_number) => `${booking_number}`,
    width: "20%",
  },
  {
    title: "Email",
    dataIndex: "email",
    filters: [
      { text: "Male", value: "male" },
      { text: "Female", value: "female" },
    ],
    width: "20%",
  },
  {
    title: "Customer Name",
    dataIndex: "text",
  },
  {
    title: "Created On",
    dataIndex: "text",
  },
  {
    title: "Booking Status",
    dataIndex: "text",
  },
  {
    title: "",
    dataIndex: "Action",
  },
];

const getRandomuserParams = (params: TableParams) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const SearchBooking = () => {
  const [form] = Form.useForm();
  const [clientReady, setClientReady] = useState<boolean>(false);

  // To disable submit button at the beginning.
  useEffect(() => {
    setClientReady(true);
  }, []);

  const onFinish = (values: any) => {
    console.log("Finish:", values);
  };
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      <Form
        form={form}
        name="search_booking"
        className="gap-16 align-end"
        layout="inline"
        onFinish={onFinish}
      >
        <Form.Item
          className="filterTextfieldBox"
          label="Search"
          rules={[
            { required: true, message: "Please input your search keywords!" },
          ]}
        >
          <Input className="searchInputField" />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Country"
          rules={[{ required: true, message: "Please select created from!" }]}
        >
          <Select
            className="searchInputField"
            defaultValue="All"
            options={[
              { value: "All", label: "All" },
              { value: "Travel Date", label: "Travel created" },
              { value: "Deadline Date", label: "Deadline created" },
            ]}
          />
        </Form.Item>

        <Form.Item
          className="filterTextfieldBox"
          label="Status"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Select
            className="searchInputField"
            defaultValue="All"
            options={[
              { value: "All", label: "All" },
              { value: "Travel Date", label: "Travel created" },
              { value: "Deadline Date", label: "Deadline created" },
            ]}
          />
        </Form.Item>
        <Form.Item className="" shouldUpdate>
          {() => (
            <Button type="primary" size="large" danger className="px-5">
              Search
            </Button>
          )}
        </Form.Item>
      </Form>

      <div>
        {isVisible && (
          <Card>
            <Form
              form={form}
              name="search_booking"
              className="search_booking"
              layout="inline"
            >
              <Form.Item
                label="Service Type"
                name="serviceType"
                className="filterTextfieldBox"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Hotel", label: "Hotel" },
                    { value: "Activities", label: "Activities" },
                    { value: "Meal", label: "Meal" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label="Payment Type"
                name="paymentType"
                className="filterTextfieldBox"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Credit Limit", label: "Credit Limit" },
                    { value: "Activities", label: "Activities" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                className="filterTextfieldBox"
                label="Agent & SubAgent"
                name="agentSubAgent"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "SUB_mridul", label: "SUB_mridul" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                className="filterTextfieldBox"
                label="Source"
                name="source"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Website", label: "Website" },
                    { value: "Mobile", label: "Mobile" },
                  ]}
                />
              </Form.Item>
              <Form.Item
                className="filterTextfieldBox"
                label="Record Per Page"
                name="recordPerPage"
              >
                <Select
                  className="searchInputField"
                  defaultValue="All"
                  options={[
                    { value: "50", label: "50" },
                    { value: "100", label: "100" },
                    { value: "500", label: "500" },
                  ]}
                />
              </Form.Item>
              <Form.Item className="d-flex align-end mr-0">
                <Button type="primary" htmlType="submit">
                  Advance Search
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}
      </div>
    </>
  );
};

const BookingData = () => {
  const navigate = useNavigate();

  const onRowClick = (event: any) => {
    navigate("/home/booking/edit");
  };
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const setAgeSort = () => {
    setSortedInfo({
      order: "descend",
      columnKey: "age",
    });
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Agent Code",
      dataIndex: "agentCode",
      key: "agentCode",
    },
    {
      title: "Agent Name",
      dataIndex: "agentName",
      key: "agentName",
    },
    {
      title: "Company",
      dataIndex: "company",
      key: "company",
    },
    {
      title: "Credit Limit",
      dataIndex: "creditLimit",
      key: "creditLimit",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Is Authorized",
      dataIndex: "isAuthorized",
      key: "isAuthorized",
    },
    {
      title: "Resend Credential",
      dataIndex: "resendCredential",
      key: "resendCredential",
    },
    {
      title: "Report",
      dataIndex: "report",
      key: "report",
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
    },
  ];

  const data = [
    {
      agentCode: "1",
      agentName: "John Brown",
      company: "AGT-900",
      creditLimit: "New York No. 1 Lake Park",
      status: <Tag color="green">Completed</Tag>,
      isAuthorized: "Mr. Gharju",
      resendCredential: "2",
      report: "0",
      edit: "0",
    },
    {
      agentCode: "1",
      agentName: "John Brown",
      company: "AGT-900",
      creditLimit: "New York No. 1 Lake Park",
      status: <Tag color="green">Completed</Tag>,
      isAuthorized: "Mr. Gharju",
      resendCredential: "2",
      report: "0",
      edit: "0",
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        onChange={handleChange}
        className="mt-4"
      />
    </>
  );
};

export const AgentProfile = () => {
  return (
    <CardBox
      title={
        <Typography.Title
          level={2}
          color="danger"
          className="mb-0 mt-0 primary-color font-weight-700"
        >
          Agent &nbsp;
          <Text type="danger" className="header-font-title">
            Profile
          </Text>
        </Typography.Title>
      }
    >
      <Card className="topBox">
        <SearchBooking />
      </Card>
      <Card>
        <Flex justify="space-between">
          <Text type="secondary" className="d-block mb-2">
            Showing 1 to 10 of 800 records
          </Text>
          <Button
            shape="round"
            color="primary"
            variant="outlined"
            className="menu-button"
          >
            Create Agent
          </Button>
        </Flex>

        <BookingData />
      </Card>
    </CardBox>
  );
};

export default AgentProfile;
